import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { AuthenticationService } from '@app/services/authentication.service';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 * Attaches X-Partner-No header when a partner is selected.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!/^(http|https):/i.test(request.url)) {
      request = request.clone({ url: environment.apiUrl + request.url });
    }

    const partnerNo = this.authService.currentSelectedPartner?.no;
    if (partnerNo) {
      request = request.clone({ setHeaders: { 'X-Partner-No': partnerNo } });
    }

    return next.handle(request);
  }
}
